import "./ClientActivityLogComponent.scss";
import {useCallback, useEffect, useRef, useState} from "react";
import commonService from "../../shared/services/common.service";
import LoaderComponent from "../../shared/components/loader/LoaderComponent";
import StatusCardComponent from "../../shared/components/status-card/StatusCardComponent";
import ActivityLogTimelineComponent from "../../shared/components/activity-log-timeline/ActivityLogTimelineComponent";
import SearchComponent from "../../shared/components/search/SearchComponent";
import DateRangePickerComponent from "../../shared/components/form-controls/date-range-picker/DateRangePickerComponent";
import moment from "moment";
import CardComponent from "../../shared/components/card/CardComponent";
import CardsPaginationComponent from "../../shared/components/cards-pagination/CardsPaginationComponent";

interface ClientActivityLogComponentProps {

}

const clientActivityLogFilterInitialValues = {
    start_date: null,
    end_date: null,
    date_range: [null, null],
    search: ""
}
const ClientActivityLogComponent = (props: ClientActivityLogComponentProps) => {

    const [clientsActivityLogs, setClientsActivityLogs] = useState<any[]>();
    const [clientsActivityLogsLoading, setClientsActivityLogsLoading] = useState<boolean>(false);
    const [clientsActivityLogsLoadingFailed, setClientsActivityLogsLoadingFailed] = useState<boolean>(false);
    const [clientsActivityLogsLoaded, setClientsActivityLogsLoaded] = useState<boolean>(false);
    const [clientActivityLogFilterState, setClientActivityLogFilterState] = useState<any>(clientActivityLogFilterInitialValues);
    const pageNumRef = useRef<number>(0);
    const totalResultsRef = useRef<number>(0);
    const pageSizeRef = useRef<number>(20);

    const getClientActivityLogs = useCallback(() => {
        const payload = {...clientActivityLogFilterState, page: pageNumRef.current, limit: pageSizeRef.current}
        setClientsActivityLogsLoaded(false);
        setClientsActivityLogsLoading(true);
        setClientsActivityLogsLoadingFailed(false);
        commonService._client.getClientActivityLogs(payload)
            .then((res: any) => {
                setClientsActivityLogsLoaded(true);
                setClientsActivityLogsLoading(false);
                setClientsActivityLogsLoadingFailed(false);
                setClientsActivityLogs(res?.data?.docs);
                pageNumRef.current = res?.data?.page;
                pageSizeRef.current = res?.data?.limit;
                totalResultsRef.current = res?.data?.total;
            })
            .catch((err: any) => {
                setClientsActivityLogsLoaded(true);
                setClientsActivityLogsLoading(false);
                setClientsActivityLogsLoadingFailed(true);
                commonService._alert.showToast(err?.error)
            })
    }, [clientActivityLogFilterState]);

    useEffect(() => {
        getClientActivityLogs();
    }, [getClientActivityLogs]);

    const handlePageNumberChange = useCallback((event: unknown, newPage: number) => {
        pageNumRef.current = newPage;
        getClientActivityLogs();
    }, [getClientActivityLogs]);

    return (
        <div className={'client-activity-log-component'}>
            <div className={"activity-log-header"}>Activity Log</div>
            <CardComponent>
                <div className="ts-col-md-8 d-flex ts-justify-content-start pdd-top-5">
                    <SearchComponent
                        label={""}
                        placeholder={"Search Activity"}
                        value={clientActivityLogFilterState.search}
                        onChange={(value) => {
                            setClientActivityLogFilterState({...clientActivityLogFilterState, search: value})
                        }}
                    />&nbsp;&nbsp;&nbsp;&nbsp;
                    <DateRangePickerComponent
                        label={""}
                        placeholder={"Date Range"}
                        value={clientActivityLogFilterState.date_range}
                        onChange={(value: any) => {
                            setClientActivityLogFilterState((oldState: any) => {
                                return {
                                    ...oldState,
                                    start_date: value[0] ? moment(value[0]).format('YYYY-MM-DD') : null,
                                    end_date: value[1] ? moment(value[1]).format('YYYY-MM-DD') : null,
                                    date_range: value
                                }
                            })
                        }}
                    />
                </div>
                {
                    clientsActivityLogsLoading && <div>
                        <LoaderComponent/>
                    </div>
                }
                {
                    clientsActivityLogsLoadingFailed &&
                    <StatusCardComponent title={"Failed to fetch client Activity logs"}/>
                }
                {
                    clientsActivityLogsLoaded &&
                    <>
                        <ActivityLogTimelineComponent
                            logsData={clientsActivityLogs}
                        />
                        <CardsPaginationComponent page={pageNumRef.current} totalResultsRef={totalResultsRef}
                                                  onPageChange={handlePageNumberChange}/>
                    </>
                }
            </CardComponent>

        </div>
    );

};

export default ClientActivityLogComponent;
